import * as tslib_1 from "tslib";
import { GraphQueryableInstance, GraphQueryableCollection, defaultPath } from "./graphqueryable";
import { jsS } from "@pnp/common";
// import { Attachments } from "./attachments";
var Calendars = /** @class */ (function (_super) {
    tslib_1.__extends(Calendars, _super);
    function Calendars() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Calendars = tslib_1.__decorate([
        defaultPath("calendars")
    ], Calendars);
    return Calendars;
}(GraphQueryableCollection));
export { Calendars };
var Calendar = /** @class */ (function (_super) {
    tslib_1.__extends(Calendar, _super);
    function Calendar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Calendar.prototype, "events", {
        get: function () {
            return new Events(this);
        },
        enumerable: true,
        configurable: true
    });
    return Calendar;
}(GraphQueryableInstance));
export { Calendar };
var Events = /** @class */ (function (_super) {
    tslib_1.__extends(Events, _super);
    function Events() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Events.prototype.getById = function (id) {
        return new Event(this, id);
    };
    /**
     * Adds a new event to the collection
     *
     * @param properties The set of properties used to create the event
     */
    Events.prototype.add = function (properties) {
        var _this = this;
        return this.postCore({
            body: jsS(properties),
        }).then(function (r) {
            return {
                data: r,
                event: _this.getById(r.id),
            };
        });
    };
    Events = tslib_1.__decorate([
        defaultPath("events")
    ], Events);
    return Events;
}(GraphQueryableCollection));
export { Events };
var Event = /** @class */ (function (_super) {
    tslib_1.__extends(Event, _super);
    function Event() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // TODO:: when supported
    // /**
    //  * Gets the collection of attachments for this event
    //  */
    // public get attachments(): Attachments {
    //     return new Attachments(this);
    // }
    /**
     * Update the properties of an event object
     *
     * @param properties Set of properties of this event to update
     */
    Event.prototype.update = function (properties) {
        return this.patchCore({
            body: jsS(properties),
        });
    };
    /**
     * Deletes this event
     */
    Event.prototype.delete = function () {
        return this.deleteCore();
    };
    return Event;
}(GraphQueryableInstance));
export { Event };
//# sourceMappingURL=calendars.js.map